var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2673 2.21084C10.9674 1.92516 10.4926 1.9367 10.2069 2.23663C9.92125 2.53655 9.93279 3.01129 10.2327 3.29697L16.4841 9.25159H1.75C1.33579 9.25159 1 9.58737 1 10.0016C1 10.4158 1.33579 10.7516 1.75 10.7516H16.4842L10.2327 16.7063C9.93279 16.992 9.92125 17.4667 10.2069 17.7666C10.4926 18.0666 10.9674 18.0781 11.2673 17.7924L18.6862 10.7257C18.8551 10.5648 18.9551 10.3596 18.9861 10.1462C18.9952 10.0994 19 10.0511 19 10.0016C19 9.95202 18.9952 9.90357 18.986 9.85669C18.955 9.64345 18.855 9.43836 18.6862 9.27755L11.2673 2.21084Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.b4dad127.svg";
export { ForwardRef as ReactComponent };